import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const CheckboxIndeterminate: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 10 2" {...props}>
    <rect x="0" y="0" width="10" height="1.5" rx="0.75"></rect>
  </Icon>
);
